import React, { Component, PropTypes } from 'react'

const COLOR_CELL_WIDTH = '65px'
const LOCATION_CELL_WIDTH = '35px'
const LOCATION_INPUT_WIDTH = '33px'
const TABLE_WIDTH = (COLOR_CELL_WIDTH + 2 * LOCATION_CELL_WIDTH) + 'px'
class ChallengeMakerForm extends Component {
  parsePositionValue(value) {
    return value === '' ? value : Number(value)
  }

  onRobotFocus(e) {
    e.target.select()
  }

  onRobotChange(e, color, y, x) {
    if (y === null) y = this.parsePositionValue(e.target.value)
    if (x === null) x = this.parsePositionValue(e.target.value)
    this.props.changeNewChallengeRobot({ color, location: [y, x] })
  }

  renderRobotsTable() {
    const { robot } = this.props
    return (
      <table style={{ tableLayout: 'fixed', width: TABLE_WIDTH }}>
        <thead>
          <tr>
            <th style={{ width: COLOR_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>Color</th>
            <th style={{ width: LOCATION_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>Y</th>
            <th style={{ width: LOCATION_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>X</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(robot).map((color) => {
            let obj = robot[color]
            let colorLabel = color[0].toUpperCase() + color.slice(1)
            return (
              <tr key={ color }>
                <td style={{ width: COLOR_CELL_WIDTH }}>{ colorLabel }</td>
                <td style={{ width: LOCATION_CELL_WIDTH }}>
                  <input type="number" className="text-input" style={{ maxWidth: LOCATION_INPUT_WIDTH }}
                         value={ obj && obj.location[0] } disabled={ this.props.newChallenge.submitted }
                         onFocus={ this.onRobotFocus.bind(this) }
                         onChange={ e => this.onRobotChange(e, color, null, obj && obj.location[1]) } />
                </td>
                <td style={{ width: LOCATION_CELL_WIDTH }}>
                  <input type="number" className="text-input" style={{ maxWidth: LOCATION_INPUT_WIDTH }}
                         value={ obj && obj.location[1] } disabled={ this.props.newChallenge.submitted }
                         onFocus={ this.onRobotFocus.bind(this) }
                         onChange={ e => this.onRobotChange(e, color, obj && obj.location[0], null) } />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  onGoalFocus(e, goal_num) {
    this.props.selectGoal(goal_num)
  }

  onGoalChange(e, goal_num, color, y, x) {
    if (color === null) color = e.target.value
    if (y === null) y = this.parsePositionValue(e.target.value)
    if (x === null) x = this.parsePositionValue(e.target.value)
    this.props.changeGoal({ goal_num, color, goal: [y, x] })
  }

  renderGoalsTable() {
    const { goals } = this.props
    const { currentRecordIndex, records } = goals
    return (
      <table style={{ tableLayout: 'fixed', width: TABLE_WIDTH }}>
        <thead>
          <tr>
            <th style={{ width: COLOR_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>Color</th>
            <th style={{ width: LOCATION_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>Y</th>
            <th style={{ width: LOCATION_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>X</th>
          </tr>
        </thead>
        <tbody>
          {records.map((obj, goal_num) => {
            return (
              <tr key={ goal_num } style={{ backgroundColor: goal_num === currentRecordIndex ? 'yellow' : '' }}>
                <td style={{ width: COLOR_CELL_WIDTH, textAlign: 'left', paddingLeft: '5px' }}>
                  <select value={ obj && obj.goalColor } disabled={ this.props.newChallenge.submitted }
                          onFocus={ e => this.onGoalFocus(e, goal_num) }
                          onChange={ e => this.onGoalChange(e, goal_num, null, obj && obj.goal[0], obj && obj.goal[1]) }>
                    { ['blue', 'green', 'red', 'yellow'].map(function(goalColor) {
                      let goalColorLabel = goalColor[0].toUpperCase() + goalColor.slice(1)
                      return <option value={ goalColor } key={ goalColor } >{ goalColorLabel }</option>
                    })}
                  </select>
                </td>
                <td>
                  <input type="number" className="text-input" style={{ maxWidth: LOCATION_INPUT_WIDTH }}
                         value={ obj && obj.goal[0] } disabled={ this.props.newChallenge.submitted }
                         onFocus={ e => { e.target.select(); this.onGoalFocus(e, goal_num) } }
                         onChange={ e => this.onGoalChange(e, goal_num, obj && obj.goalColor, null, obj && obj.goal[1]) } />
                </td>
                <td>
                  <input type="number" className="text-input" style={{ maxWidth: LOCATION_INPUT_WIDTH }}
                         value={ obj && obj.goal[1] } disabled={ this.props.newChallenge.submitted }
                         onFocus={ e => { e.target.select(); this.onGoalFocus(e, goal_num) } }
                         onChange={ e => this.onGoalChange(e, goal_num, obj && obj.goalColor, obj && obj.goal[0], null) } />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.makeChallenge(this.props.newChallenge.challengeId, this.props.newChallenge.config)
  }

  renderSubmit() {
    if (! this.props.newChallenge.submitted) {
      return <input type="submit" className="submit-button"/>
    }
    else {
      return <strong>Challenge submitted! challengeId: { this.props.newChallenge.challengeId }</strong>
    }
  }

  onConfigChange(e) {
    this.props.changeNewChallengeConfig(e.target.value)
  }

  render() {
    return (
      <form onSubmit = { this.handleSubmit.bind(this) } style={{ marginLeft: '20px' }}>
        <h3>Config</h3>
        <input type="text" className="text-input" value={ this.props.newChallenge.config } disabled={ this.props.newChallenge.submitted }
               onChange={ this.onConfigChange.bind(this) } />
        <h3>Robots</h3>
        { this.renderRobotsTable() }
        <h3>Goals</h3>
        { this.renderGoalsTable() }
        Challenge ID: { this.props.newChallenge.challengeId }
        <br />
        <br />
        { this.renderSubmit() }
        <div className="error">{ this.props.newChallenge.error }</div>
      </form>
    )
  }
}

export default ChallengeMakerForm



// WEBPACK FOOTER //
// ./components/ChallengeMakerForm.js